import axios from 'axios'

const API = '/api/'
const SECURE = 'secure'
const FULL = API + SECURE

// =========================== LOJAS ===========================
//  ######################### ADESÃO #######################
/*
Permission: Admin, Pesquisador
Params: pageSize
Action: Retorna todas as lojas a serem aderidas
*/
export async function GET_LOJAS_ADESAO (pageSize) {
    return await axios.get(`${FULL}/lojas/adesao/${pageSize}`)
}

/*
Permission: Admin, Pesquisador
Params: pageSize, filters
Action: Retorna todas as lojas a serem aderidas filtradas
*/
export async function GET_LOJAS_ADESAO_FILTER (pageSize, filters) {
    return await axios.get(`${FULL}/lojas/adesao/${pageSize}` + (!Object.values(filters).every(x => x === '') ? '?' : '') +
    (filters.cnpj ? `cnpj=${filters.cnpj}` : '') +
    (filters.razao ? `&razao_social=${filters.razao}` : '') +
    (filters.nome ? `&nome_fantasia=${filters.nome}` : '') +
    (filters.segmento ? `&segmento_id=${filters.segmento}` : '') +
    (filters.regulamentacao ? `&regulamentacao_id=${filters.regulamentacao}` : '') +
    (filters.regiao ? `&regiao_id=${filters.regiao}` : '') +
    (filters.faturamento ? `&faturamento_id=${filters.faturamento}` : '') +
    (filters.page ? `&page=${filters.page}` : '') +
    (filters.corrente ? `&corrente=${filters.corrente}` : '') +
    (filters.status ? `&status_id=${filters.status}` : '')
    )
}

/*
Permission: Admin
Params: body = {cnpj}
Action: Cria uma nova loja de adesao
*/
export async function POST_ADESAO (body) {
    return await axios.post(`${FULL}/lojas/adesao/criar`, body)
}

/*
Permission: Admin
Params: body = {file}
Action: Importa lojas de adesao a partir de um arquivo excel
*/
export async function IMPORT_ADESAO (file) {
    return await axios.post(`${FULL}/import/lojas/adesao`, file, { headers: { 'Content-Type': 'multipart/form-data' } })
}
//  ######################### ATIVAS #######################
/*
Permission: Admin, Pesquisador
Params: segmento_id
Action: Retorna todas as marcas de um segmento
*/
export async function GET_LOJAS_ATIVAS (pageSize) {
    return await axios.get(`${FULL}/lojas/ativas/paginate/${pageSize}`)
}

/*
Permission: Admin, Pesquisador
Params: pageSize, filters
Action: Retorna todas as lojas ativas filtradas
*/
export async function GET_LOJAS_ATIVAS_FILTER (pageSize, filters) {
    return await axios.get(`${FULL}/lojas/ativas/paginate/${pageSize}` + (!Object.values(filters).every(x => x === '') ? '?' : '') +
    (filters.cnpj ? `cnpj=${filters.cnpj}` : '') +
    (filters.razao ? `&razao_social=${filters.razao}` : '') +
    (filters.nome ? `&nome_fantasia=${filters.nome}` : '') +
    (filters.segmento ? `&segmento_id=${filters.segmento}` : '') +
    (filters.regulamentacao ? `&regulamentacao_id=${filters.regulamentacao}` : '') +
    (filters.status ? `&status_id=${filters.status}` : '') +
    (filters.regiao ? `&regiao_id=${filters.regiao}` : '') +
    (filters.faturamento ? `&faturamento_id=${filters.faturamento}` : '') +
    (filters.page ? `&page=${filters.page}` : '') +
    (filters.pesquisador_id ? `&pesquisador_id=${filters.pesquisador_id}` : '') +
    (filters.corrente ? `&corrente=${filters.corrente}` : '')
    )
}

/*
Permission: Admin
Params: id
Action: Retorna uma loja especifica
*/
export async function GET_LOJA_ATIVA_BY_ID (id) {
    return await axios.get(`${FULL}/lojas/ativas/${id}`)
}

/*
Permission: Admin, Pesquisador
Params: body = {cnpj}
Action: Transforma uma loja adesão em uma loja ativa
*/
export async function ADESAO_TO_ATIVA (body) {
    return await axios.post(`${FULL}/lojas/ativas`, body)
}

/*
Permission: Admin
Params: body = {cnpj}
Action: Atualiza os dados de uma loja ativa
*/
export async function PUT_ATIVA (id, body) {
    return await axios.put(`${FULL}/lojas/ativas/${id}`, body)
}
// =========================== AUTH ===========================
export async function POST_LOGOUT () {
    return await axios.post(`${FULL}/logout`)
}

/*
Permission: None
Params: body = {email}
Action: Realiza o pedido de redefinicao de senha
*/
export async function POST_REDEFINIR_SENHA (email) {
    return await axios.post(`${API}redefinirsenha`, { email: email })
}

/*
Permission: None
Params: body = {email, token, password, confirm}
Action: Realiza o pedido de redefinicao de senha
*/
export async function POST_MUDAR_SENHA (body) {
    return await axios.post(`${API}mudarsenha`, body)
}

/*
Permission: Admin, Pesquisador
Params: None
Action: Retorna todas as regulamentacoes
*/
export async function GET_REGULAMENTACOES () {
    return await axios.get(`${FULL}/regulamentacoes`)
}

/*
Permission: Admin, Pesquisador
Params: None
Action: Retorna todos os segmentos
*/
export async function GET_SEGMENTOS () {
    return await axios.get(`${FULL}/segmentos`)
}

/*
Permission: Admin, Pesquisador
Params: None
Action: Retorna todas as regioes
*/
export async function GET_REGIOES () {
    return await axios.get(`${FULL}/regioes`)
}

/*
Permission: Admin, Pesquisador
Params: None
Action: Retorna todos os tipos de faturamentos
*/
export async function GET_FATURAMENTOS () {
    return await axios.get(`${FULL}/faturamentos`)
}

// =========================== PRODUTOS ===========================
// Um produto e composto por marca + modelo + complemento

/*
Permission: Admin
Params: segmento_id
Action: Retorna todas as marcas de um segmento
*/
export async function GET_MARCAS_BY_SEGMENTO (segmento_id) {
    return await axios.get(`${FULL}/produtos/marcas/${segmento_id}`)
}

/*
Permission: Admin
Params: marca_id
Action: Retorna todos os modelos de um marca
*/
export async function GET_MODELOS_BY_MARCA (marca_id) {
    return await axios.get(`${FULL}/produtos/marcas/modelos/${marca_id}`)
}

/*
Permission: Admin
Params: modelo_id
Action: Retorna todos os complementos de um modelo
*/
export async function GET_COMPLEMENTOS_BY_MODELO (modelo_id) {
    return await axios.get(`${FULL}/produtos/marcas/modelos/complementos/${modelo_id}`)
}

/*
Permission: Admin
Params: body
Action: Cria um novo produto
*/
// export async function POST_PRODUTOS(body) {
//     return await axios.post(`${FULL}/lojas/produtos`, body)
// }

/*
Permission: Admin
Params: body = {cnpj}
Action: Retorna todos os produtos cadastrados numa loja
*/
export async function GET_PRODUTOS_BY_LOJA (loja_id) {
    return await axios.get(`${FULL}/lojas/produtos/${loja_id}`)
}

/*
Permission: Admin
Params: body = {cnpj, produto_id}
Action: Adiciona um novo produto a uma loja
*/
export async function POST_PRODUTOS_LOJA (body) {
    return await axios.post(`${FULL}/lojas/produtos`, body)
}

/*
Permission: Admin
Params: loja_id, body = {marca_id, modelo_id, complemento_id}
Action: Remove um novo produto de uma loja
*/
export async function DELETE_PRODUTOS_LOJA (loja_id, body) {
    return await axios.delete(`${FULL}/lojas/produtos/${loja_id}/${body.marca_id}/${body.modelo_id}/${body.complemento_id}`)
}

/*
Permission: Admin
Params: body = {segmento}
Action: Cria um novo segmento
*/
export async function POST_SEGMENTOS (body) {
    return await axios.post(`${FULL}/produtos/segmento`, body)
}

/*
Permission: Admin
Params: body = {segmento_id, marca}
Action: Cria uma nova marca
*/
export async function POST_MARCAS (body) {
    return await axios.post(`${FULL}/produtos/marca`, body)
}

/*
Permission: Admin
Params: body = {segmento_id, marca_id, modelo}
Action: Cria um novo modelo
*/
export async function POST_MODELOS (body) {
    return await axios.post(`${FULL}/produtos/modelo`, body)
}

/*
Permission: Admin
Params: body = {segmento_id, marca_id, modelo_id, complemento}
Action: Cria um novo complemento
*/
export async function POST_COMPLEMENTO (body) {
    return await axios.post(`${FULL}/produtos/complemento`, body)
}

// =========================== HISTORICO ===========================
/*
Permission: Admin, Pesquisador
Params: CNPJ
Action: Retorna todos os contatos feitos com um loja de adesao
*/
export async function GET_HISTORICO_CONTATOS_ADESAO (cnpj) {
    return await axios.get(`${FULL}/historico/contatos/adesao/${cnpj}`)
}
/*
Permission: Admin, Pesquisador
Params: id
Action: Retorna todos os contatos feitos com um loja ativa
*/
export async function GET_HISTORICO_CONTATOS_ATIVAS (id) {
    return await axios.get(`${FULL}/historico/contatos/ativa/${id}`)
}

/*
Permission: Admin, Pesquisador
Params: None
Action: Cria um novo registro de contato para uma loja ativa
*/
export async function POST_HISTORICO_CONTATOS_ATIVAS (body) {
    return await axios.post(`${FULL}/historico/contatos/ativa`, body)
}
/*
Permission: Admin, Pesquisador
Params: None
Action: Cria um novo registro de contato para uma loja de adesao
*/
export async function POST_HISTORICO_CONTATOS_ADESAO (body) {
    return await axios.post(`${FULL}/historico/contatos/adesao`, body)
}

/*
Permission: Admin
Params: lojaId
Action: Reverte a ação do último histórico de contato de uma loja ativa
*/
export async function REVERT_HISTORICO_CONTATOS_ATIVA (lojaId) {
    return await axios.delete(`${FULL}/historico/contatos/ativa/status/${lojaId}`)
}
/*
Permission: Admin
Params: cnpj
Action: Reverte a ação do último histórico de contato de uma loja de adesao
*/
export async function REVERT_HISTORICO_CONTATOS_ADESAO (cnpj) {
    return await axios.delete(`${FULL}/historico/contatos/adesao/status/${cnpj}`)
}
/*
Permission: Admin
Params: cnpj
Action: Reverte a ação do último histórico de contato de uma loja de adesao
*/
export async function VERIFICAR_STATUS_ANOMES (lojaId, statusId, anoMes) {
    return await axios.get(`${FULL}/historico/contatos/${lojaId}/${statusId}/${anoMes}`)
}

// =========================== PESQUISADOR ===========================
/*
Permission: Admin
Params: None
Action: Retorna todos o pesquisadores cadastrados e ativos
*/
export async function GET_PESQUISADORES_ADMIN () {
    return await axios.get(`${FULL}/pesquisadores`)
}
/*
Permission: Admin
Params: Pesquisador id
Action: Define um pesquisador para lojas adesão
*/
export async function PUT_PESQUISADORES_ADESAO (pesquisadorId, body) {
    return await axios.put(`${FULL}/lojas/adesao/pesquisador/${pesquisadorId}`, body)
}
/*
Permission: Admin
Params: Pesquisador id
Action: Define um pesquisador para lojas ativas
*/
export async function PUT_PESQUISADORES_ATIVAS (pesquisadorId, body) {
    return await axios.put(`${FULL}/lojas/ativas/pesquisador/${pesquisadorId}`, body)
}

// =========================== ENDEREÇO ===========================
/*
Permission: Admin
Params: None
Action: Cria um novo endereço
*/
export async function POST_ENDERECO () {
    return await axios.get(`${FULL}/endereco`)
}
/*
Permission: Admin
Params: Id
Action: Retorna um endereco a partir de um id
*/
export async function GET_ENDERECO (id) {
    return await axios.get(`${FULL}/endereco/${id}`)
}
/*
Permission: Admin
Params: Id
Action: Atualiza um endereco a partir de um id
*/
export async function PUT_ENDERECO (id) {
    return await axios.put(`${FULL}/endereco/${id}`)
}
/*
Permission: Admin
Params: Id
Action: Retorna um endereco a partir de um id
*/
export async function GET_UFS () {
    return await axios.get(`${FULL}/endereco`)
}

// =========================== STATUS CONTATO ===========================
/*
Permission: Admin, Pesquisador
Params: None
Action: Retorna os status os quais classificam os contatos para loja adesao
*/
export async function GET_STATUS_CONTATO_ADESAO () {
    return await axios.get(`${FULL}/status/adesao`)
}
/*
Permission: Admin, Pesquisador
Params: None
Action: Retorna os status os quais classificam os contatos para loja ativa
*/
export async function GET_STATUS_CONTATO_ATIVAS () {
    return await axios.get(`${FULL}/status/ativo`)
}

// =========================== RECOLHA ===========================

/*
Permission: Admin, Pesquisador
Params: body = {
                    recolha: {
                        loja_id,
                        ano_mes,
                    },
                    produtos: {
                        marca_id,
                        modelo_id,
                        complemento_id,
                        quantidade,
                        valor,
                        observacao
                    }
                }
Action: Salva uma recolha com o status de editavel para ser possivel edita-la posteriormente
*/
export async function POST_RECOLHA_EM_PROGRESSO (body) {
    return await axios.post(`${FULL}/recolhas/emprogresso`, body)
}

/*
Permission: Admin, Pesquisador
Params: body = {
                    recolha: {
                        loja_id,
                        ano_mes,
                    },
                    produtos: {
                        marca_id,
                        modelo_id,
                        complemento_id,
                        quantidade,
                        valor,
                        observacao
                    }
                }
Action: Cria uma nova recolha
*/
export async function POST_RECOLHA (body) {
    return await axios.post(`${FULL}/recolhas`, body)
}
/*

Permission: Admin, Pesquisador
Params: loja_id
Action: Retorna os dados da ultima recolha realizada
*/
export async function GET_ULTIMA_RECOLHA (loja_id) {
    return await axios.get(`${FULL}/recolhas/${loja_id}`)
}
/*

Permission: Admin, Pesquisador
Params: loja_id, ano_mes
Action: Retorna os dados de recolha num periodo especificado
*/
export async function GET_RECOLHA_RECOLHA_BY_ANOMES (loja_id, ano_mes) {
    return await axios.get(`${FULL}/recolhas/${loja_id}/${ano_mes}`)
}

// =========================== USUÁRIO ===========================
/*
Permission: None
Params: None
Action: Cria um novo usuario
*/
export async function POST_USUARIO (body) {
    return await axios.post(`${API}registrar`, body)
}

/*
Permission: Admin
Params: None
Action: Retorna todos os usuarios cadastrados
*/
export async function GET_USUARIOS () {
    return await axios.get(`${FULL}/usuarios`)
}

/*
Permission: Admin
Params: None
Action: Retorna todos os usuarios cadastrados
*/
export async function GET_USUARIOS_FILTER (filters) {
    return await axios.get(`${FULL}/usuarios` + (!Object.values(filters).every(x => x === '') ? '?' : '') +
    (filters.nome ? `&nome=${filters.nome}` : '') +
    (filters.page ? `&page=${filters.page}` : '')
    )
}

/*
Permission: Admin
Params: None
Action: Retorna um usuarios cadastrado especifico
*/
export async function GET_USUARIO_BY_ID (id) {
    return await axios.get(`${FULL}/usuarios/${id}`)
}

/*
Permission: Admin, Pesquisador (somente para atualiza os seus proprios dados)
Params: None
Action: Atualiza um usuario
*/
export async function PUT_USUARIO (id, body) {
    return await axios.put(`${FULL}/usuarios/${id}`, body)
}

export async function POST_AVATAR (body) {
    const headers = {
        'Content-Type': 'multipart/form-data'
    }
    return await axios.post(`${FULL}/usuarios/avatar`, body, headers)
}

export async function CHANGE_PASSWORD (body) {
    return await axios.post(`${FULL}/usuarios/alterar/senha`, body)
}

// =========================== Métricas ===========================

/*
Permission: Admin
Params: anoMes
Action: Exporta dados sobre recolhas a partir de um dado ano-mes
*/
export async function EXPORTAR_RECOLHAS (anoMes) {
    return await axios.get(`${FULL}/recolhas/report/${anoMes}`, { responseType: 'blob' })
}
/*
Permission: Admin
Params: none
Action: Retorna os resultados das importacoes das lojas
*/
export async function RESULTADO_IMPORTACOES () {
    return await axios.get(`${FULL}/import/lojas/adesao/results`)
}
/*
Permission: Admin, Pesquisador (somente para visualizar os seus proprios dados)
Params: anoMes
Action: Retorna as quantidades de recolhas feitas e as pendentes
*/
export async function METRICAS_PESSOAS (anoMes) {
    return await axios.get(`${FULL}/dashboard/metricas/${anoMes}`)
}

export async function REQUEST_CALL (phone) {
    return await axios.get(`${FULL}/request/call/${phone}`)
}

/*
Permission: Admin
Params: anoMes
Action: Exporta dados de toda base das lojas ativas
*/
export async function EXPORTAR_ATIVAS () {
    return await axios.get(`${FULL}/lojas/ativas/report`, { responseType: 'blob' })
}
